import { render, staticRenderFns } from "./Reels.vue?vue&type=template&id=659496b9&scoped=true"
import script from "./Reels.vue?vue&type=script&lang=js"
export * from "./Reels.vue?vue&type=script&lang=js"
import style0 from "./Reels.vue?vue&type=style&index=0&id=659496b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659496b9",
  null
  
)

export default component.exports